import { config } from '@/config/bzbsconfig.js';
import { config as configDev } from '@/config/bzbsconfig.dev.js';
import { config as configStg } from '@/config/bzbsconfig.stg.js';
import { config as configPrd } from '@/config/bzbsconfig.prd.js';

export default {
    install(Vue) {
        let configEnvObj = {};
        try {
            configEnvObj = JSON.parse(window.configEnv || '{}');
        } catch (e) {
            console.warn('[vueconfig] failed to parse window.configEnv:', e);
        }

        let appConfig = null;
        switch (configEnvObj.build) {
            case 'dev':
                appConfig = configDev;
                break;
            case 'stg':
                appConfig = configStg;
                break;
            case 'prd':
                appConfig = configPrd;
                break;
            default:
                appConfig = config;
                break;
        }

        appConfig = Object.assign(appConfig, configEnvObj);

        Vue.bzbsConfig = appConfig;
    }
}
